var map = {
	"./empty-announcement.png": "f104",
	"./empty-code.png": "b968",
	"./empty-content.png": "12b6",
	"./empty-data.png": "03e0",
	"./empty-md-announcement.png": "3285",
	"./empty-md-content.png": "f4ac",
	"./empty-md-data.png": "a779",
	"./empty-md-task.png": "77bd",
	"./empty-network.png": "3dcb",
	"./empty-news.png": "61c6",
	"./empty-permission.png": "6977",
	"./empty-timetable.png": "83cd",
	"./empty-web.png": "9f3a",
	"./image-fail.png": "19c1",
	"./image-loading.png": "5808",
	"./no-data.png": "3b91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4f9";